import { useStyles } from '@team-griffin/stylr';
import { breakpoints, useBreakpoints } from '@ux/responsive';
import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px, useTheme } from '@uds/theme-utils';
import { Layout } from 'domain/constants/layout';

import { getActiveAnchor, halfContainerWidth } from '../styles';

export default (props: { layout: Layout; duoLayout: boolean }) => {
  const { layout, duoLayout } = props;
  const breakpointProps = useBreakpoints();
  const { isMinSm, isMinMd, isMinLg, isMinXl } = breakpointProps;
  const { theme } = useTheme();
  const { anchor } = layout;

  const startDuoLayout = layout.startDuoLayout || false;
  // @ts-ignore: error after upgrading to ux-configs
  const activeAnchor = getActiveAnchor(anchor, breakpointProps);

  return useStyles(
    {
      default: {
        content: {
          flex: 1,
          flexBasis: 'auto',
          justifyContent: activeAnchor,
          display: 'flex',
          flexDirection: 'column',
        },
        duoLayout: {
          ...cssSides('padding', Side.X, gu2px(1, theme.spacing)),
          ...cssSides('margin', Side.X, 'auto'),
          width: '100%',
          maxWidth: '100%',
        },
      },

      isMinSm: {
        duoLayout: {
          maxWidth: breakpoints.sm - gu2px(1, theme.spacing),
        },
      },

      isDuoLayoutMd: {
        duoLayout: {
          maxWidth: halfContainerWidth(breakpoints.md, theme.spacing),
          marginLeft: 0,
        },
      },
      isDuoLayoutLg: {
        duoLayout: {
          maxWidth: halfContainerWidth(breakpoints.lg, theme.spacing),
        },
      },
      isDuoLayoutXl: {
        duoLayout: {
          maxWidth: halfContainerWidth(breakpoints.xl, theme.spacing),
        },
      },
      startDuoLayout: {
        duoLayout: {
          marginRight: 0,
          marginLeft: 'auto',
        },
      },
    },
    [
      { activeAnchor },
      { isMinSm },
      { isDuoLayoutMd: duoLayout && isMinMd },
      { isDuoLayoutLg: duoLayout && isMinLg },
      { isDuoLayoutXl: duoLayout && isMinXl },
      { startDuoLayout },
    ],
  );
};
